<div class="p-card-list" [@cardsTransitions]="provider?.loadingState">

  <div class="p-card-content">
    <div class="p-card-instance" *ngFor="let item of dataSource | async | keyvalue">

      <mat-card>

        <ng-template
          [ngTemplateOutlet]="pagedCardTemplate"
          [ngTemplateOutletContext]="{$implicit: item.value}">
        </ng-template>

      </mat-card>

    </div>
  </div>

  <mat-paginator [length]="resultsLength" [pageSize]="provider!.page.pageSize"></mat-paginator>

</div>
